import { ApiClient } from "../ApiClient";
export function CustomerContextSwitcher() {
    return {
        async onCustomerContextChange(e) {
            const apiClient = new ApiClient("/api/users");
            const rambaseId = parseInt(e.target.value);
            await apiClient.put("/me/rambase-context", { rambaseId });
            location.reload();
        }
    };
}
